const defaultColumnPreferences = {
        email: false,
        userId: false
};

export default defaultColumnPreferences;